import { render, staticRenderFns } from "./card-limited.vue?vue&type=template&id=02835086&"
import script from "./card-limited.vue?vue&type=script&lang=js&"
export * from "./card-limited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports